module.exports = __webpack_public_path__ + "img/298c359.jpg";